<template>
  <div class="cookie__button">
    <button
      class="cookie__button-label apollo__link"
      tabindex="0"
      role="button"
      aria-pressed="true"
      @click="accept"
    >
      <bdi>{{ label }}</bdi>
    </button>
  </div>
</template>

<script>
export default {
  name: 'CookieButton',

  props: {
    label: {
      type: String,
      required: true,
    },
  },

  methods: {
    accept() {
      localStorage.setItem('cookie:accepted', '1');
      this.$parent.$emit('cookie-accepted');
    },
  },
};
</script>

<style lang="scss" scoped>
.cookie__button {
  display: inline;

  @include mq(ipadP) {
    display: block;
  }
}
.cookie__button button {
  position: relative;
  cursor: pointer;

  @at-root [data-theme="default"] & {
    background-color: transparent;
    text-align: center;
    border: none;
    -webkit-appearance: none;
    appearance: none;
    font-weight: 400;
    padding: 0px;
    color: $color-text;

    @include mq($and: $is-touch-device) {
      color: $color-text;
    }

    @include mq(ipadP) {
      padding: 0px 20px;
    }

    @include mq(d) {
      padding: 0px 30px;
    }

    transition: color 0.4s ease-out;

    bdi {
      position: relative;
      vertical-align: text-bottom;
      display: inline-block;
      overflow: hidden;
      text-shadow: -2px -2px $color-bg, -2px 2px $color-bg,
      2px -2px $color-bg, 2px 2px $color-bg;
    }

    &:hover {
      color: $color-text;
    }
  }
}
</style>
